import {CardItem} from "../../../../components/CardItem/CardItem";
import {GetCardTypeImage} from "../../../../components/getTypeCard/GetTypeCard";
import {CreditCardStatus, ICardItem} from "../../../../models/payment/ICard";
import React, {useCallback} from "react";
import {Drawer, Modal} from "@material-ui/core";
import styles from "../TablePaymentSelect.module.scss";
import {NewCard} from "../../../newCard/NewCard";
import {VerifyModal} from "../../../payment/PaymentSelect/verifyModal/VerifyModal";
import {PaymentType} from "../../../../models/payment/IPay";
import {useTablePayment} from "../../../../context/tablePayment/TablePaymentContext";

const PaymentCardModal = () => {
    const {
        card,
        cards,
        openVerifyCard,
        openAddCard,
        setPaymentType,
        setOpenVerifyCard,
        setCard,
        onPressDeleteCard,
        setOpenAddCard,
        getCards,
        setSelectCardOpen,
    } = useTablePayment();

    const onClickSelectCard = useCallback((card: ICardItem | null) => {
        if (card) {
            setCard && setCard(card);
            setSelectCardOpen(false);
        }
    }, [setCard, setSelectCardOpen]);

    const onClickCard = useCallback((card: ICardItem) => {
        setPaymentType(PaymentType.CREDITO);
        onClickSelectCard(card);
    }, [onClickSelectCard, setPaymentType]);

    const onCloseVerifyCard = useCallback(() => {
        setOpenVerifyCard(false);
        getCards();
        if (card) {
            setCard && setCard({...card, status: CreditCardStatus.VALIDATED});
        }
    }, [card, getCards, setCard, setOpenVerifyCard]);

    const onCloseAddNewCard = useCallback(() => {
        setOpenAddCard(false);
        getCards();
    }, [getCards, setOpenAddCard]);

    return (<>
            <div className={styles.modalContent}>
                <div style={{
                    position: "relative",
                    paddingTop: 16,
                    paddingBottom: 16,
                    margin: "auto",
                    maxHeight: "70vh"
                }}>
                    <div className={styles.headerTitle}>
                        <span>{!cards?.length ? 'Adicione um novo cartão' : 'Escolha uma opção'}</span>
                    </div>
                    {cards && cards.map((card: ICardItem) => (
                        <CardItem
                            textTop={`xxxx.xxxx.xxxx.${card.finalNumber}`}
                            textBottom={card.brandDescription}
                            imageSrc={GetCardTypeImage(card.brandDescription)}
                            onClick={() => onClickCard(card)}
                            autenticated={card.status === CreditCardStatus.VALIDATED}
                            key={card.id}
                            onClickRemove={() => {
                                onPressDeleteCard(card);
                            }}
                            iconName="credit_card"
                        />))}
                    <CardItem textTop={"Cartão de Crédito"} onClickAdd={() => setOpenAddCard(true)}
                              onClick={() => setOpenAddCard(true)} iconName="credit_card"/>

                    <Modal open={openAddCard} onClose={() => setOpenAddCard(false)} className={styles.modalContainer}>
                        <NewCard onCancel={() => onCloseAddNewCard()} onConfirm={() => onCloseAddNewCard()}></NewCard>
                    </Modal>
                    {card && (
                        <Drawer anchor="bottom" open={openVerifyCard} onBackdropClick={() => setOpenVerifyCard(false)}>
                            <VerifyModal card={card} open={openVerifyCard} onValidate={() => onCloseVerifyCard()}/>
                        </Drawer>)}
                </div>
            </div>
        </>)
}

export default PaymentCardModal;